<template>
  <div>
    <img
      class="mx-auto h-96 w-center"
      src="@//assets/icons/Slagboom-persoon.svg"
    />
    <card-title>Hoeveel gebruikers mogen er parkeren</card-title>
 

    <fieldset class="flex flex-col my-3" id="gebruikers">
      <label
        v-for="option in this.pages[1]['options']"
        :key="option.price"
        :for="option.id"
        class="inline-flex items-center mt-3"
      >
        <input
          @click="setValueChild('stap-2', option.price, option.title)"
          :checked="option.selected == true"
          :id="option.id"
          type="radio"
          value="20"
          name="group2"
          class="
            form-radio
            h-5
            w-5
            text-primary
            checked:bg-primary checked:border-4
            bg-transparent
            border-primary border-2
          "
        /><span class="ml-2">{{ option.title }}</span>
      </label>
    </fieldset>


    <btn-group-bottom 
    previous="stap-1" 
    next="stap-3" 
    :current="this.pages[1]['slug']" 
    @InlineButtonClickHandler="InlineButtonClickHandler"
    />

  </div>
</template>

<script>
export default {
  name: "Stap2",
  props: {
    pages: Array,
    totalPrice: Number,
  },
  methods: {
    addChild(i) {
      this.$emit("add", i);
    },
    InlineButtonClickHandler(current) {
      this.$emit("InlineButtonClickHandler", current);
    },
    removeChild(i) {
      this.$emit("remove", i);
    },
    setValueChild(key, value, title) {
      this.$emit("setValue", key, value, title);
    },
  },
  mounted: function () {
  },
  inheritAttrs: false, // disable 'non-props' warning
};
</script>
